import { gql } from "apollo-angular";

export const GETALL_TAGS_QUERY = gql`query configuratorAllTags {
    configuratorAllTags
  }
  `
